import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import withNavigation from './withNavigation';
var EventNameToPropName = {
  willFocus: 'onWillFocus',
  didFocus: 'onDidFocus',
  willBlur: 'onWillBlur',
  didBlur: 'onDidBlur'
};
var EventNames = Object.keys(EventNameToPropName);

var NavigationEvents = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationEvents, _React$Component);

  var _super = _createSuper(NavigationEvents);

  function NavigationEvents() {
    var _this;

    _classCallCheck(this, NavigationEvents);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getPropListener", function (eventName) {
      return _this.props[EventNameToPropName[eventName]];
    });

    return _this;
  }

  _createClass(NavigationEvents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // We register all navigation listeners on mount to ensure listener stability across re-render
      // A former implementation was replacing (removing/adding) listeners on all update (if prop provided)
      // but there were issues (see https://github.com/react-navigation/react-navigation/issues/5058)
      this.subscribeAll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.navigation !== prevProps.navigation) {
        this.removeAll();
        this.subscribeAll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeAll();
    }
  }, {
    key: "subscribeAll",
    value: function subscribeAll() {
      var _this2 = this;

      this.subscriptions = {};
      EventNames.forEach(function (eventName) {
        _this2.subscriptions[eventName] = _this2.props.navigation.addListener(eventName, function () {
          var propListener = _this2.getPropListener(eventName);

          return propListener && propListener.apply(void 0, arguments);
        });
      });
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var _this3 = this;

      EventNames.forEach(function (eventName) {
        _this3.subscriptions[eventName].remove();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return NavigationEvents;
}(React.Component);

export default withNavigation(NavigationEvents);